import { Box, styled } from "@mui/material";
import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const CustomImageSlider = styled(Box)(({ theme }) => ({
  ".view-image": {
    //background:"red",
  },
}));
const ProductImageSlider = ({ images, altText }) => {
  const imageObjects = images?.map((img, index) => ({ original: img?.src, originalAlt: `${altText} Image-${index+1}` }));
  return imageObjects ? (
    <CustomImageSlider>
      <Box className="view-image">
        <ImageGallery
          lazyLoad={true}
          items={imageObjects}
          showBullets={false}
          showNav={true}
          showPlayButton={false}
          autoPlay={false}
          loading={"lazy"}
          onSlide={(currentIndex) => {
            localStorage.setItem("slided", "true");
          }}
        />
      </Box>
    </CustomImageSlider>
  ) : null;
};

export default ProductImageSlider;
